import React from 'react';
import '../less/index.less';
import DOMPurify from 'utils/sanitize';
import hero_background_line from '../img/hero_background_line.svg'
import { ReactSVG } from 'react-svg';
import { Link } from 'MWC';

export default function template() {
  const {btnLink, btntext, btnTarget, btnId, title, text, heroRef, reversedBgLine, images} = this.props;

  return (
    <div className="hero-home" ref={heroRef}>
      <div className="container">
        <ReactSVG 
          src={hero_background_line} 
          className={`hero-home__line${reversedBgLine ? ' hero-home__line_reversed' : ''}`}
          beforeInjection={svg => {
            svg.setAttribute('viewBox', '0 0 1920 689');
            svg.setAttribute('preserveAspectRatio', 'xMidYMin slice');
            const path = svg.querySelector('path');
            if (path) path.setAttribute('transform', 'translate(-50,32)');
            if (path) path.setAttribute('stroke-width', '114');
          }}
        />
        <div className="hero-home__content">
          <h1 className="hero-home__title" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(title))}}></h1>
          <div className="hero-home__text">{this.l10n(text)}</div>
          {btnTarget === "_self" ? (
            <Link 
              href={btnLink} 
              onClick={e => this.navigate(btnLink, e)} 
              className="hero-home__btn" 
              id={btnId}
              target={btnTarget}
            >
              {this.l10n(btntext)}
            </Link>
          ) : (
            <a 
              className="hero-home__btn" 
              href={btnLink}
              target={btnTarget}
              id={btnId}
            >
              {this.l10n(btntext)}
            </a>
          )}
          {images && images.map((img, index) => (
            <img key={index} src={img} className={`hero-home__image hero-home__image_${index + 1}`} alt={`hero image ${index + 1}`} />
          ))}
        </div>
      </div>
    </div>
  );
}

